/**
 * 登录流程时间追踪工具
 * 用于记录登录过程中各个步骤的耗时
 */

interface LoginTiming {
  startTime: number; // 开始时间戳
  clickSubmitTime?: number; // 点击提交按钮时间戳
  sendCodeStartTime?: number; // 发送验证码开始时间戳
  sendCodeEndTime?: number; // 发送验证码结束时间戳
  loginRequestStartTime?: number; // 登录请求开始时间戳
  loginRequestEndTime?: number; // 登录请求结束时间戳
  totalDuration?: number; // 总耗时（毫秒）
}

export const useLoginTiming = () => {
  const timing = ref<LoginTiming>({
    startTime: Date.now(),
  });

  // 记录点击提交按钮时间
  const recordClickSubmit = () => {
    timing.value.clickSubmitTime = Date.now();
    return timing.value.clickSubmitTime - timing.value.startTime;
  };

  // 记录发送验证码开始时间
  const recordSendCodeStart = () => {
    timing.value.sendCodeStartTime = Date.now();
  };

  // 记录发送验证码结束时间
  const recordSendCodeEnd = () => {
    timing.value.sendCodeEndTime = Date.now();
    return (
      (timing.value.sendCodeEndTime || 0) -
      (timing.value.sendCodeStartTime || timing.value.startTime)
    );
  };

  // 记录登录请求开始时间
  const recordLoginRequestStart = () => {
    timing.value.loginRequestStartTime = Date.now();
  };

  // 记录登录请求结束时间
  const recordLoginRequestEnd = () => {
    timing.value.loginRequestEndTime = Date.now();
    return (
      (timing.value.loginRequestEndTime || 0) -
      (timing.value.loginRequestStartTime || timing.value.startTime)
    );
  };

  // 计算总耗时
  const calculateTotalDuration = () => {
    const endTime = Date.now();
    timing.value.totalDuration = endTime - timing.value.startTime;
    return timing.value.totalDuration;
  };

  // 获取各步骤耗时
  const getTimingData = () => {
    const data: Record<string, number> = {};

    // 从开始到点击提交的耗时
    if (timing.value.clickSubmitTime) {
      data.click_submit_duration = timing.value.clickSubmitTime - timing.value.startTime;
    }

    // 发送验证码耗时
    if (timing.value.sendCodeStartTime && timing.value.sendCodeEndTime) {
      data.send_code_duration = timing.value.sendCodeEndTime - timing.value.sendCodeStartTime;
    }

    // 登录请求耗时
    if (timing.value.loginRequestStartTime && timing.value.loginRequestEndTime) {
      data.login_request_duration =
        timing.value.loginRequestEndTime - timing.value.loginRequestStartTime;
    }

    // 总耗时
    if (timing.value.totalDuration) {
      data.total_duration = timing.value.totalDuration;
    } else {
      data.total_duration = Date.now() - timing.value.startTime;
    }

    return data;
  };

  // 重置时间追踪
  const reset = () => {
    timing.value = {
      startTime: Date.now(),
    };
  };

  return {
    timing: readonly(timing),
    recordClickSubmit,
    recordSendCodeStart,
    recordSendCodeEnd,
    recordLoginRequestStart,
    recordLoginRequestEnd,
    calculateTotalDuration,
    getTimingData,
    reset,
  };
};
